import React from 'react';
import { IconButton, Typography, Stack, CircularProgress } from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { useLikes } from '../hooks/useLikes';
import type { LikeTargetType } from '../types';

export interface LikeButtonProps {
  targetType: LikeTargetType;
  targetId: string;
  initialIsLiked?: boolean;
  initialCount?: number;
}

/**
 * Like button with counter for trips and pins.
 */
export function LikeButton({ targetType, targetId, initialIsLiked = false, initialCount = 0 }: LikeButtonProps) {
  const { isLiked, likesCount, isLoading, toggleLike } = useLikes(
    targetType,
    targetId,
    initialIsLiked,
    initialCount,
  );

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <IconButton
        size="small"
        onClick={toggleLike}
        disabled={isLoading}
        color={isLiked ? 'error' : 'default'}
        aria-label={isLiked ? 'Unlike' : 'Like'}
      >
        {isLoading ? (
          <CircularProgress size={18} />
        ) : isLiked ? (
          <FavoriteIcon fontSize="small" />
        ) : (
          <FavoriteBorderIcon fontSize="small" />
        )}
      </IconButton>
      <Typography variant="body2" color="text.secondary">
        {likesCount}
      </Typography>
    </Stack>
  );
}
